import { H1PlusSmall, H4 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexColumn } from 'styles/layouts';

export const Wrapper = styled(FlexColumn)<{ background?: string }>`
  gap: 57px;
  padding: 57px 16px 40px;
  background-color: var(--color-bg-surface-secondary);

  ${QUERIES.laptopAndUp} {
    padding: 63px 48px 48px;
    background-image: url(${({ background }) => background ?? ''});
    background-position: center top -172px;
    background-repeat: no-repeat;
  }
`;

export const Title = styled(H1PlusSmall)`
  text-align: center;
`;

export const Subline = styled(H4)`
  max-width: 860px;
  text-align: center;
  font-weight: ${themeStyle.fontBold};
  color: ${themeStyle.varInkMedium};
  margin: 0 auto;
`;
